// @ts-expect-error - Automatic, Please fix when editing this file
const selectCheckout = (state) => state?.checkout;

export default selectCheckout;
